import React from 'react';
import { ServicesSection } from '../components/ServicesSection';
import { CTABanner } from '../components/CTABanner';
export function ServicesPage() {
  return <main data-id="element-386">
      {/* Hero Banner */}
      <section className="bg-slate-900 py-20 text-center px-4" data-id="element-387">
        <div className="container mx-auto max-w-3xl" data-id="element-388">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-389">
            Our Services
          </h1>
          <p className="text-xl text-slate-300" data-id="element-390">
            Comprehensive logistics solutions designed to meet the demands of
            modern businesses and individuals across the UK.
          </p>
        </div>
      </section>

      <ServicesSection data-id="element-391" />

      {/* Additional Details */}
      <section className="py-20 bg-slate-50" data-id="element-392">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-393">
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12" data-id="element-394">
            <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-395">
              Why Our Services Stand Out
            </h2>
            <div className="space-y-6 text-slate-600" data-id="element-396">
              <p data-id="element-397">
                At Global Universal Logistics, we understand that every delivery
                is unique. Whether you need an emergency parcel delivered across
                the country or a dedicated team for an office relocation, we
                have the expertise and resources to handle it.
              </p>
              <p data-id="element-398">
                Our fleet is equipped to handle items of all sizes, and our
                drivers are trained to ensure the utmost care is taken with your
                goods. We pride ourselves on our punctuality, reliability, and
                professional approach to every job.
              </p>
              <p data-id="element-399">
                By choosing us, you're partnering with a logistics company that
                values your time and peace of mind.
              </p>
            </div>
          </div>
        </div>
      </section>

      <CTABanner data-id="element-400" />
    </main>;
}